import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../../../services/account/account.service';
import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { CustomerEntryPass } from '../../../../../../../../../models/entry-pass';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../../utils';

@Component({
  selector: 'app-edit-customer-entry-pass-modal',
  templateUrl: './edit-customer-entry-pass-modal.component.html',
  styleUrls: ['./edit-customer-entry-pass-modal.component.css']
})
export class EditCustomerEntryPassModalComponent implements OnInit {

  @Input() entryPass: CustomerEntryPass;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingSubmit = false;

  public serverError: number = null;

  public errors: any = {};
  public errorMessage = '';

  constructor(
    private accountService: AccountService,
    private customerService: CustomerService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    // Create a deep copy of the entry pass so we don't edit the parent list.
    // Note: this only works as long as no nested objects are edited.
    const entryPassCopy = {};
    for (const key of Object.keys(this.entryPass)) {
      entryPassCopy[key] = this.entryPass[key];
    }
    this.entryPass = entryPassCopy as CustomerEntryPass;
  }

  public handleSave() {
    this.loadingSubmit = true;
    this.errors = {};
    this.errorMessage = '';

    this.customerService
      .updateCustomerEntryPass(this.entryPass)
      .then(() => {
        this.savedCallback({
          status: CallbackResultStatus.success,
          text: 'Entry pass updated successfully.'
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit this pass.';
        } else if (reason.status === 400) {
          this.errorMessage = 'Please correct the errors above and try again.';
          this.errors = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
